import Vue from 'vue'
import VueRouter from 'vue-router'
import SpellPage from '../pages/SpellPage.vue'
import EquipmentPage from '../pages/EquipmentPage.vue'
import MagicItemPage from '../pages/MagicItemPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Spells',
    component: SpellPage
  },
  {
    path: '/equipment',
    name: 'Equipment',
    component: EquipmentPage
  },
  {
    path: '/magic_items',
    name: 'Magic Items',
    component: MagicItemPage
  },

]

const router = new VueRouter({
  routes
})

export default router
